/**
 * Modulo de Seeders.
 *
 * A tela e unificada: mostra os seeders de todas as aplicacoes da plataforma,
 * nao so os do accounts. Quem registra sao as proprias aplicacoes, no boot; a
 * tela marca o que deve rodar e mostra o que aconteceu.
 */
export const nav = {
    permissao: 'accounts.seeders:ver',
    section: 'Resources',
    title: 'Seeders',
    icon: 'database',
    route: '/seeders',
    accordion: false,
};

export default [
    {
        path: '/seeders',
        name: '/seeders',
        component: () => import('./pages/SeedersListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.seeders:ver' },
    },
    {
        path: '/seeders/:id',
        name: 'seeder-historico',
        component: () => import('./pages/SeederPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'accounts.seeders:editar' },
    },
];
